export default "__VITE_ASSET__Cs6sLrYH__"